module.exports = __webpack_public_path__ + "img/7-0-2.ad81dff4.png";